
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otp",
      function () {
        return require("private-next-pages/otp/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otp"])
      });
    }
  